

// Lokalen PHP-Server starten:
// cd /Users/99grad/Webprojekte/tetronik-terminal/public
// php -S localhost:8081


// Host-Name ermitteln
if (process.env.IS_ELECTRON) {
    if (process.env.NODE_ENV == 'development') {
        var baseUrl = './';
    } else {
        var baseUrl = 'app://./';
    }
} else if (window.location.hostname == 'localhost') {
    var baseUrl = 'http://localhost:' + window.location.port + '/';  
} else {
    var baseUrl = window.location.protocol + '//' + window.location.host + '/';
}

export const BASE_URL = baseUrl;

// Pfad zur Backend-Api
export const API_URL    = BASE_URL + "api/";
export const ASSETS_URL = BASE_URL + "assets/";
export const DATA_URL   = BASE_URL + "data/";
